import {
  createFormState,
  required,
  numberGreaterThanOrEqualTo,
} from 'redux-freeform';

const closeoutFormConfig = {
  cashTotal: {
    defaultValue: '0',
    validators: [numberGreaterThanOrEqualTo(0)],
    constraints: [numberGreaterThanOrEqualTo(0)],
  },
  confirmAmounts: {
    defaultValue: false,
    validators: [required()],
  },
  notes: {},
  float: {
    // A default should probably not be hardcoded here
    defaultValue: '0.00',
    constraints: [numberGreaterThanOrEqualTo(0)],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(closeoutFormConfig);
